import { render, staticRenderFns } from "./drg-platform.vue?vue&type=template&id=59aa3307"
import script from "./drg-platform.vue?vue&type=script&lang=js"
export * from "./drg-platform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports